/* proposalDisplay.js
 *
 * ONE rule for what the "Services Included" section displays, shared by the
 * admin proposal editor and the client portal.
 *
 * WHY THIS FILE EXISTS. The two surfaces each carried their own copy of a
 * substitution rule. The admin copy was corrected on Aug 28 to fill only a
 * genuinely empty section. The client copy was not, so it kept swapping any
 * stored text under 160 plain characters with no U+2022 character for the
 * generated item list. Measured on production Aug 29: on 2 of 11 live
 * proposals the admin's saved wording sat correct in the database while the
 * client was shown the generated list. An HTML <ul> contains no U+2022
 * characters, so a short real list written by the admin always tripped it.
 *
 * THE RULE, AND IT IS THE WHOLE RULE: what the admin saved is what the client
 * sees. Generated items fill the section only when nothing was saved at all.
 * There is no length test, no shape test, and no guess about intent.
 *
 * Any new surface that renders this section imports from here. It must not
 * carry its own copy of this logic.
 */
// Strip markup and collapse whitespace so "is anything actually written here"
// is answered on the words, not on the tags around them.
export function plainTextOf(value) {
  return String(value ?? '').replace(/<[^>]*>/g, ' ').replace(/\s+/g, ' ').trim();
}
export function servicesItemsAsText(serviceItems) {
  const items = Array.isArray(serviceItems) ? serviceItems : [];
  return items
    .map((it) => `\u2022 ${it.name}${it.description ? ` \u2014 ${it.description}` : ''}`)
    .join('\n');
}
// Returns what should be DISPLAYED. It never returns a value that should be
// saved back over the stored field.
export function resolveServicesIncluded(storedValue, serviceItems) {
  const items = Array.isArray(serviceItems) ? serviceItems : [];
  if (plainTextOf(storedValue).length > 0) return storedValue;
  if (items.length >= 2) return servicesItemsAsText(items);
  return storedValue;
}
